import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Component from './Component';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, selectedItem, error, message, newItem,
  } = state.market;
  return {
    isLoading,
    selectedItem,
    error,
    message,
    newItem,
  };
}

const Styled = withStyles(styles)(Component);

export default connect(
  mapStateToProps,
)(Styled);
